import * as React from 'react';

import { EventFieldOptions, ReportType } from '../api/clients';

import ErrorOverlay from '../../components/ErrorOverlay';
import LoadingOverlay from '../../components/LoadingOverlay';
import useGetEventReportFieldOptions from '../api/hooks/event-report/useGetEventReportFieldOptions';

const IncidentFieldOptionsContext = React.createContext<EventFieldOptions>(undefined!);

// eslint-disable-next-line max-len
export function IncidentFieldOptionsProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const incidentFieldOptions = useGetEventReportFieldOptions(ReportType.Incident);

  if (incidentFieldOptions.isLoading) {
    return (
      <LoadingOverlay />
    );
  }

  if (incidentFieldOptions.status === 'error') {
    return (
      <ErrorOverlay
        title={incidentFieldOptions?.error?.title}
        message="An error occurred retrieving data"
      />
    );
  }

  if (incidentFieldOptions.data) {
    return (
      <IncidentFieldOptionsContext.Provider value={incidentFieldOptions.data}>
        {children}
      </IncidentFieldOptionsContext.Provider>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment />;
}

export const useIncidentFieldOptions = () => React.useContext(IncidentFieldOptionsContext);
